"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importDefault(require("react"));
var mobx_react_1 = require("mobx-react");
var review_star_1 = __importDefault(require("@hikakaku/shared/components/common/review_star"));
var CompanyInfo = (0, mobx_react_1.observer)(function (_a) {
    var store = _a.store;
    return (react_1.default.createElement("div", { className: "estimateForm-CompanyInfo" },
        react_1.default.createElement("div", { className: "estimateForm-CompanyInfo_InnerRow" },
            react_1.default.createElement("img", { src: store.companyInfo.logo, alt: store.companyInfo.name, className: "estimateForm-CompanyInfo_Image lazyload" }),
            react_1.default.createElement("div", null,
                react_1.default.createElement("div", { className: "estimateForm-CompanyInfo_StoreName" }, store.companyInfo.name),
                react_1.default.createElement(review_star_1.default, { breakLine: true, showRateNumber: true, size: "s", rate: store.companyInfo.rating, reviewRateNumberClass: "estimateForm-CompanyInfo_ReviewRateNumber" }))),
        react_1.default.createElement("div", { className: "estimateForm-CompanyInfo_Description" }, store.companyInfo.description)));
});
exports.default = CompanyInfo;
